import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import {
  HomeFilled,
  FileAddOutlined,
  ProfileOutlined,
  LeftSquareOutlined,
  RightSquareOutlined,
  InfoCircleFilled,
} from '@ant-design/icons';
import logo from '../../images/logo.svg';
import './SideNav.css';

interface IProps {
  collapsed: boolean;
  setCollapsed: (currentState: boolean) => void;
}

const SideNav: React.FC<IProps> = (props: IProps) => {
  const { collapsed, setCollapsed } = props;
  const location = useLocation();

  const collapseIcon = collapsed ? (
    <RightSquareOutlined />
  ) : (
    <LeftSquareOutlined />
  );

  return (
    <>
      <div
        className={`${collapsed ? 'Dashboard-Collapsed' : 'Dashboard-Logo'} `}
      >
        <img src={logo} alt="logo" />
      </div>
      <Menu
        mode="inline"
        selectedKeys={[location!.pathname]}
        className={collapsed ? 'SideNav-collapsed' : ''}
      >
        <Menu.Item key="/" icon={<HomeFilled />} className="SideNav-menu-item">
          {!collapsed && location!.pathname === '/' && (
            <div className="SideNav-menu-pointer" />
          )}
          Tracker Home
          <Link to="/" />
        </Menu.Item>
        <Menu.Item
          key="/submit"
          icon={<FileAddOutlined />}
          className="SideNav-menu-item"
        >
          {!collapsed && location!.pathname === '/submit' && (
            <div className="SideNav-menu-pointer" />
          )}
          Submit Event
          <Link to="/submit" />
        </Menu.Item>
        <Menu.Item
          key="/events"
          icon={<ProfileOutlined />}
          className="SideNav-menu-item"
        >
          {!collapsed && location!.pathname === '/events' && (
            <div className="SideNav-menu-pointer" />
          )}
          View All Events
          <Link to="/events" />
        </Menu.Item>
        <Menu.Item
          key="/help"
          icon={<InfoCircleFilled />}
          className="SideNav-menu-item"
        >
          {!collapsed && location!.pathname === '/help' && (
            <div className="SideNav-menu-pointer" />
          )}
          Help
          <Link to="/help" />
        </Menu.Item>
        <Menu.Item
          icon={collapseIcon}
          onClick={() => setCollapsed(collapsed)}
          className="SideNav-menu-item"
        >
          {collapsed ? 'Open Menu' : 'Collapse Menu'}
        </Menu.Item>
      </Menu>
    </>
  );
};

export default SideNav;
